export const LocalStorageKeys = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  USER_PROFILE: "userProfile",
  PROFILE_PICTURE: "ProfilePicture",
  ONBOARDING: "onboarding",
  IS_EXTENSION: "isExtension",
  API_PASSWORD: "apiPassword",
};
